<template>
    <div>
        <b-modal v-model="isOpenModal" id="sendMessageConfirmationModal"  :hide-header="true"
                 :hide-footer="true">
            <div class="col-12 col-md-12">
                <p>{{$t('title.inputFieldChangedMessage')}}</p>
            </div>
            <div class="modal-footer d-flex mr-2 gap-2">
                <b-button type="button" variant="primary" class="col m-0" @click="cancelModal">
                    {{ $t('title.continue') }}
                </b-button>
                <b-button type="button" variant="secondary" class="col m-0" @click="goBack">
                    {{ $t('title.cancel') }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {request} from "@/Util/Request";
import Error from "@/Util/Error";
export default {
    data() {
        return {
            isOpenModal: false,
        };
    },
    methods: {
        async handleToggleModal() {
            this.isOpenModal = !this.isOpenModal;
        },
       
        cancelModal() {
            this.isOpenModal = false;
        },
        goBack() {
            this.$emit('back');
        },
    }
};
</script>
